import { createOid } from '@verdant-web/common';
import { getRange } from './ranges.js';
import { isAbortError } from '../idb.js';
function getStore(db, collection, write) {
    return db
        .transaction(collection, write ? 'readwrite' : 'readonly')
        .objectStore(collection);
}
export async function findOneOid({ collection, index, context, }) {
    const store = getStore(context.documentDb, collection);
    const source = (index === null || index === void 0 ? void 0 : index.where) ? store.index(index.where) : store;
    const range = getRange(context.schema, collection, index);
    const direction = (index === null || index === void 0 ? void 0 : index.order) === 'desc' ? 'prev' : 'next';
    const request = source.openCursor(range, direction);
    const result = await new Promise((resolve, reject) => {
        request.onsuccess = () => {
            const cursor = request.result;
            if (cursor) {
                resolve(createOid(collection, cursor.primaryKey.toString()));
            }
            else {
                resolve(null);
            }
        };
        request.onerror = () => {
            var _a;
            if (((_a = request.error) === null || _a === void 0 ? void 0 : _a.name) === 'InvalidStateError') {
                context.log('error', `findOne query failed with InvalidStateError`, request.error);
                resolve(null);
            }
            else if (isAbortError(request.error)) {
                resolve(null);
            }
            else {
                reject(request.error);
            }
        };
    });
    return result;
}
export async function findAllOids({ collection, index, context, }) {
    const store = getStore(context.documentDb, collection);
    const source = (index === null || index === void 0 ? void 0 : index.where) ? store.index(index.where) : store;
    const range = getRange(context.schema, collection, index);
    const direction = (index === null || index === void 0 ? void 0 : index.order) === 'desc' ? 'prev' : 'next';
    const request = source.openCursor(range, direction);
    const result = await new Promise((resolve, reject) => {
        const results = new Set();
        request.onsuccess = () => {
            const cursor = request.result;
            if (cursor) {
                results.add(createOid(collection, cursor.primaryKey.toString()));
                cursor.continue();
            }
            else {
                resolve(Array.from(results));
            }
        };
        request.onerror = () => {
            var _a;
            if (((_a = request.error) === null || _a === void 0 ? void 0 : _a.name) === 'InvalidStateError') {
                context.log('error', `findAll query failed with InvalidStateError`, request.error);
                resolve([]);
            }
            else if (isAbortError(request.error)) {
                resolve([]);
            }
            else {
                reject(request.error);
            }
        };
    });
    return result;
}
export async function findPageOfOids({ collection, index, context, limit, offset, }) {
    const store = getStore(context.documentDb, collection);
    const source = (index === null || index === void 0 ? void 0 : index.where) ? store.index(index.where) : store;
    const range = getRange(context.schema, collection, index);
    const direction = (index === null || index === void 0 ? void 0 : index.order) === 'desc' ? 'prev' : 'next';
    const request = source.openCursor(range, direction);
    let hasDoneOffset = !offset;
    let hasNextPage = false;
    let visited = 0;
    const result = await new Promise((resolve, reject) => {
        const results = new Set();
        request.onsuccess = () => {
            visited++;
            const cursor = request.result;
            if (cursor) {
                if (offset && !hasDoneOffset) {
                    cursor.advance(offset);
                    hasDoneOffset = true;
                }
                else {
                    if (limit && results.size < limit) {
                        results.add(createOid(collection, cursor.primaryKey.toString()));
                    }
                    if (limit && visited > limit) {
                        hasNextPage = true;
                        resolve(Array.from(results));
                    }
                    else {
                        cursor.continue();
                    }
                }
            }
            else {
                resolve(Array.from(results));
            }
        };
        request.onerror = () => {
            var _a;
            if (((_a = request.error) === null || _a === void 0 ? void 0 : _a.name) === 'InvalidStateError') {
                context.log('error', `find query failed with InvalidStateError`, request.error);
                resolve([]);
            }
            else if (isAbortError(request.error)) {
                resolve([]);
            }
            else {
                reject(request.error);
            }
        };
    });
    return {
        result: result,
        hasNextPage,
    };
}
//# sourceMappingURL=dbQueries.js.map